
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppImageHolder, AppFileUpload } from '@/components';
import { useCollectionAddOrEdit } from '@/modules/collection/model/add.or.edit';

export default defineComponent({
    name: 'CollectionAddOrEdit',
    components: { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppImageHolder, AppFileUpload },
    setup() {
        const { model, v$, createOrUpdate } = useCollectionAddOrEdit();

        return { v$, model, createOrUpdate };
    }
});
